import React from 'react';
import Backend from '../../../Layouts/Backend';
import { withTranslation } from 'react-i18next';
import { InputGroup, InputGroupAddon, Button, Input } from 'reactstrap';
import Datagrid from '../../../UI/Datagrid';
import { Alert } from '../../../UI/Common';
import helper from '../../../../utils/helper';
import PasswordConfirmation from '../../../UI/PasswordConfirmation';
import ReactSelect from '../../../UI/ReactSelect';

const ValidationControlPanelPage = (props) => {
  //prettier-ignore
  const { isFetching, groups, validationCP, defaultSorted, t } = props;
  const [form, setForm] = React.useState({
    groupId: undefined,
  });
  const [selected, setSelected] = React.useState({
    cell: '',
    row: {},
    name: [],
  });
  React.useEffect(() => {
    if (form.groupId !== undefined) {
      setSelected({
        row: {},
        cell: '',
        sensorId: [],
      });
      props.onChangeGroup(form.groupId);
    }
  }, [form]);
  const columns = [
    { dataField: 'location', text: 'Location' },
    {
      dataField: 'name',
      text: 'Name',
      sort: true,
    },
    {
      dataField: 'parameter',
      text: 'Parameter',
      sort: true,
    },
    {
      dataField: 'textValue',
      text: 'Value',
      sort: true,
      headerStyle: { width: 120, textAlign: 'center' },
      align: 'center',
    },
    {
      dataField: 'units',
      text: 'Units',
      sort: true,
    },
    {
      dataField: 'alarmImage',
      text: 'Status',
      sort: true,
      headerStyle: { width: 70, textAlign: 'center' },
      align: 'center',
      formatter: formatterStatus,
    },
    {
      dataField: 'timeStamp',
      text: 'Last Updated',
      sort: true,
      isDateTime: true,
      headerStyle: { width: 130 },
    },
  ];
  const selectRow = {
    mode: 'radio',
    clickToSelect: true,
    hideSelectColumn: true,
    style: { backgroundColor: '#007bff80' },
    selected: selected.sensorId,
    onSelect: handleOnSelect,
  };
  function handleOnSelect(row, isSelected) {
    if (isSelected) {
      setSelected({
        row: row,
        cell: row.textValue,
        sensorId: [row.sensorId],
      });
    } else {
      setSelected({
        row: {},
        cell: '',
        sensorId: [],
      });
    }
  }
  function formatterStatus(cell) {
    return (
      <div className="d-flex justify-content-center align-items-center">
        <img
          src={`./img/statusIcon/${cell}`}
          width={24}
          height={24}
          alt="status-icon"
          title={t(helper.getStatusIconName(cell))}
        />
      </div>
    );
  }
  function isDisabled() {
    return !selected.cell || !Object.keys(selected.row).length;
  }
  const [openModal, setOpenModal] = React.useState(false);
  const [act, setAct] = React.useState(null);
  const isRequireConfirmation = helper.isRequireConfirmation();
  function onClick(action) {
    if (isRequireConfirmation) {
      setOpenModal(true);
      setAct(() => () => action());
    } else {
      action();
    }
  }
  return (
    <Backend>
      <div className="content-inner">
        <PasswordConfirmation
          isOpen={openModal}
          onCancel={() => {
            setOpenModal(false);
            setAct(null);
          }}
          onConfirm={() => {
            setOpenModal(false);
            act();
            setAct(null);
          }}
        />
        <Alert.Error text={props.errors} />
        <ReactSelect
          required
          containerStyle={{ width: '30%' }}
          label="Group"
          options={groups}
          value={form.groupId}
          onChange={({ value }) =>
            setForm({
              groupId: value,
            })
          }
          valueKey="id"
          labelKey="name"
        />
        <div className="d-flex justify-content-between align-items-end mb-10">
          <InputGroup className="w-50">
            <Input
              value={selected.cell}
              onChange={(e) =>
                setSelected({ ...selected, cell: e.target.value })
              }
            />
            <InputGroupAddon addonType="append">
              <Button
                disabled={isDisabled()}
                onClick={() =>
                  onClick(() => props.onOverride(selected.cell, selected.row))
                }
              >
                {t('Override')}
              </Button>
              <Button
                disabled={isDisabled()}
                onClick={() =>
                  onClick(() => props.onNormal(selected.cell, selected.row))
                }
              >
                {t('Normal')}
              </Button>
            </InputGroupAddon>
          </InputGroup>
        </div>
        <Datagrid
          datagridProps={{
            keyField: 'sensorId',
            data: validationCP,
            loading: isFetching,
            columns,
            defaultSorted,
            selectRow,
          }}
          exportProps={{
            fileName: 'ValidationControlPanel',
          }}
        />
      </div>
    </Backend>
  );
};

export default withTranslation('app')(ValidationControlPanelPage);
